<script lang="ts">
    import type QuestionEntity from "@apps/reviews/entities/QuestionEntity";
    import { getHumanReadableDate } from "@lib/utils";
    import { I18nModule } from "@modules/i18n/I18nModule";
    import { container } from "tsyringe";

    import Badge from "@components/Badge/Badge.svelte";
    import T from "@components/T.svelte";
    import ViewMore from "@components/ViewMore.svelte";

    import AnswerItem from "./AnswerItem.svelte";
    import QuestionItemFrame from "./QuestionItemFrame.svelte";

    export let question: QuestionEntity;
    export let namespace: string;

    const i18nModule = container.resolve(I18nModule);
    const t_anonym$ = i18nModule.exports.i18n.selectT(namespace, "anonym");

    $: customerName = question.customer?.name ?? $t_anonym$;
</script>

<QuestionItemFrame>
    <ViewMore class="gw-qa-item__text" slot="text" text={question.body}>
        <svelte:fragment slot="view_more_text">
            <T {namespace} translationKey="view_more" />
        </svelte:fragment>
        <svelte:fragment slot="view_less_text">
            <T {namespace} translationKey="view_less" />
        </svelte:fragment>
    </ViewMore>

    <span slot="author" class="gw-qa-item__username">
        {customerName}
    </span>

    <svelte:fragment slot="verified-buyer">
        {#if question.customer?.isVerifiedBuyer}
            <Badge variant="info">
                <T {namespace} translationKey="verified_buyer" />
            </Badge>
        {/if}
    </svelte:fragment>

    <svelte:fragment slot="date">
        <div class="gw-qa-item__date">
            {getHumanReadableDate(question.createdAt)}
        </div>
    </svelte:fragment>

    <svelte:fragment slot="reply">
        {#if question.answers.length}
            <ul class="gw-qa-item__reply gw-list-reset-default-styles">
                {#each question.answers as answer (answer.id)}
                    <AnswerItem {answer} {namespace} />
                {/each}
            </ul>
        {/if}
    </svelte:fragment>
</QuestionItemFrame>

<style lang="postcss">
    .gw-qa-item {
        :global(&__text) {
            margin: 0;
            font-size: 0.875em;
        }

        &__username {
            font-size: 1em;
            font-weight: 600;
        }

        &__date {
            color: #667085;
            font-size: 0.75em;
            font-weight: 400;
            width: max-content;
        }

        &__reply {
            display: flex;
            flex-direction: column;
            gap: 0.8em;
        }
    }
</style>
